import Link from "next/link";
import { ArrowRight, Phone, User, LayoutDashboard } from "lucide-react";
import { ROUTES } from "@/config/routes";
import { site } from "@/content/site";
import { useCurrentUser } from "@/lib/auth/useCurrentUser";

export function MobileMenu({ items, onNavigate }: { items: any[], onNavigate: () => void }) {
  const { data: user } = useCurrentUser();

  return (
    <nav className="grid gap-2 border-t border-white/10 bg-black/80 backdrop-blur-2xl px-4 pb-6 pt-3 xl:hidden" aria-label="Mobile navigation">
      {items.map((item) => (
        <Link
          key={item.href}
          href={item.href}
          onClick={onNavigate}
          className="flex min-h-[44px] items-center rounded-lg px-4 text-sm font-bold text-white/90 transition hover:bg-white/10 hover:text-[var(--gold-strong)]"
        >
          {item.label}
        </Link>
      ))}

      <div className="my-2 border-t border-white/10" />

      {/* Quick Action: Call Us */}
      <a
        href={`tel:${site.phone.replaceAll(" ", "")}`}
        onClick={onNavigate}
        className="flex min-h-[44px] items-center gap-3 rounded-lg border border-white/15 bg-white/5 px-4 text-sm font-semibold text-white transition hover:bg-white/10 hover:text-[var(--accent)]"
      >
        <span className="grid size-8 place-items-center rounded-full bg-[var(--accent)]/20 text-[var(--accent)]">
          <Phone size={15} />
        </span>
        <div className="flex flex-col">
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/50">Direct Line</span>
          <span>{site.phone}</span>
        </div>
      </a>

      {/* Quick Action: User Login or Dashboard */}
      {user ? (
        <Link
          href={ROUTES.DASHBOARD || "/dashboard"}
          onClick={onNavigate}
          className="flex min-h-[44px] items-center gap-3 rounded-lg border border-white/15 bg-white/5 px-4 text-sm font-semibold text-white transition hover:bg-white/10 hover:text-[var(--accent)]"
        >
          <span className="grid size-8 place-items-center rounded-full bg-[var(--accent)] text-white text-xs font-bold uppercase">
            <LayoutDashboard size={15} />
          </span>
          <div className="flex flex-col">
            <span className="text-[10px] font-bold uppercase tracking-wider text-white/50">Logged in as {user.role || "User"}</span>
            <span className="font-semibold text-white">{user.profile?.firstName || user.username || "Dashboard"}</span>
          </div>
        </Link>
      ) : (
        <Link
          href={ROUTES.LOGIN}
          onClick={onNavigate}
          className="flex min-h-[44px] items-center gap-3 rounded-lg border border-white/15 bg-white/5 px-4 text-sm font-semibold text-white transition hover:bg-white/10 hover:text-[var(--accent)]"
        >
          <span className="grid size-8 place-items-center rounded-full bg-white/10 text-[var(--accent)]">
            <User size={15} />
          </span>
          <span>CRM / Agent Login</span>
        </Link>
      )}

      {/* Primary Action: Enquire Now */}
      <Link
        href={ROUTES.CONTACT_US}
        onClick={onNavigate}
        className="mt-1 flex min-h-[48px] items-center justify-center gap-2 rounded-lg bg-[var(--gold-strong)] px-4 text-sm font-black text-[var(--ink)] shadow-md transition hover:bg-[var(--gold)] active:scale-[0.98]"
      >
        Enquire Now <ArrowRight size={16} />
      </Link>
    </nav>
  );
}
